<template>
  <Paper class="es-config">
    <searchTenant @closeChange="searchCode" @newPush="newCode" :searchBlock='searchBlock' ref="search"></searchTenant>
   <div class="es-config-table">
        <esTable
      :tableData="tableData"
      @stateChange="stateCode"
      @changeConfig="pushConfig"
      @changeAdress="adressMenu"
      @changUser="changUser"
    ></esTable>
   </div>
   <div class="es-config-add">
    <el-button @click="newCode" icon="el-icon-plus" type="primary" size="mini" class="new-button">
        {{$translate('lang.E3202102260005', { defaultText: '新增' })}}
    </el-button>
   </div>
    <pageList  v-if="pageState" :pageMenu="pageMenu" @changeCurrent="currentDom" @changeSize="sizeDom" class="es-config-page"></pageList>
    <!-- 集群配置修改對話框 -->
    <el-dialog
      :title="config.mangeTable.dialogTitle[0].name"
      :visible.sync="dialogVisible"
      :before-close="cancelCheck"
      width="500px"
    >
      <newDelate :changeData="changeData" ref="config"></newDelate>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelCheck" size="mini" class="system-management-cancel-button">
            {{$translate('lang.E3202101270002', { defaultText: '取消' })}}
        </el-button>
        <el-button type="primary" @click="changeConfig" size="mini"  class="system-management-confirm-button" :loading="changeConfigBlock">
            {{$translate('lang.E3202103010008', { defaultText: '保存' })}}
        </el-button>
      </span>
    </el-dialog>
    <!-- 集群配置地址修改 -->
    <el-dialog :title="config.mangeTable.dialogTitle[2].name" :visible.sync="dialogVisibleAdress"  >
      <modificationAddress
        :addressSet="addressSet"
        @adressState="adressState"
        @openAdressNew="openAdressNew"
        @changeOldAdress="checkOldAdress"
      ></modificationAddress>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleAdress = false"  size="mini" class="system-management-cancel-button">
            {{$translate('lang.E3202101270002', { defaultText: '取消' })}}
        </el-button>
        <el-button type="primary" @click="dialogVisibleAdress= false"  size="mini" class="system-management-confirm-button">
            {{$translate('lang.E3202103010008', { defaultText: '保存' })}}
        </el-button>
      </span>
    </el-dialog>
    <!-- 新增、修改地址 -->
    <el-dialog
       customClass="cluster-address-modification-dialog"
      :title="$translate('lang.E3202103100016', { defaultText: '新增/修改地址' })"
      :visible.sync="newAdressOn"
      append-to-body
      :before-close="cancelTheCheck"
      width="350px"
    >
      <newAddress :oldAdress="oldAdress" ref="adressChange"></newAddress>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelTheCheck"  size="mini" class="system-management-cancel-button">
            {{$translate('lang.E3202101270002', { defaultText: '取消' })}}
        </el-button>
        <el-button type="primary"  size="mini" @click="pushAdressChange" class="system-management-confirm-button">
            {{$translate('lang.E3202103010008', { defaultText: '保存' })}}
        </el-button>
      </span>
    </el-dialog>
    <!-- 租户集群绑定 -->
    <el-dialog :title="$translate('lang.E3202103100011', { defaultText: 'ES集群用户绑定' })" :visible.sync="dialogUser"  customClass="cluster-binding-dialog" :before-close="tenantCheck">
      <el-transfer
      filterable
      v-model="bindTenant"
      :filter-placeholder="$translate('lang.E3202103100017', { defaultText: '请输入租户名称或租户代码' })"
      :props="{key: 'tenantCode',label: 'tenantCode'}"
      :titles="[$translate('lang.E3202103100012', { defaultText: '全部租户' }), $translate('lang.E3202103100013', { defaultText: '应用租户' })]"
      :data="allTenant"

    ></el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tenantCheck"  size="mini" class="system-management-cancel-button">
            {{$translate('lang.E3202101270002', { defaultText: '取消' })}}
        </el-button>
        <el-button type="primary" @click="pushEs"  size="mini" class="system-management-confirm-button">
            {{$translate('lang.E3202101270001', { defaultText: '确定' })}}
        </el-button>
      </span>
    </el-dialog>
  </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import searchTenant from './esSearch';
import esTable from './table';
import pageList from '../../../components/systemComponent/pageList';
import config from './esConfig.js';
import newDelate from './newDelate/Index';
import modificationAddress from './modificationAddress/Index';
import newAddress from './newAddress/Index';
import {
    getESIndex,
    changeInfo,
    changeState,
    getAdress,
    changeAdressState,
    adressCut,
    clusterBinding,
    newQuota,
    tenantList
} from '../../../api/systemManagementApi';
export default {
    name: 'es',
    data() {
        return {
            pageState: true,
            searchBlock: false,
            changeConfigBlock: false,
            bindTenant: [],
            allTenant: [],
            bindTenantCopy: [],
            config: config,
            headerId: '',
            oldAdress: {
                id: '',
                headerId: '',
                version: '',
                port: '',
                address: null
            },
            copyOldAdress: {
                id: '',
                version: '',
                headerId: '',
                port: '',
                address: null
            },
            dialogVisible: false,
            dialogVisibleAdress: false,
            newAdressOn: false,
            dialogUser: false,
            tableData: [],
            addressSet: [],
            changeData: {
                id: '',
                clusterName: '',
                protocal: '',
                userName: '',
                password: '',
                version: ''
            },
            copyChangeData: {
                id: '',
                clusterName: '',
                protocal: 'HTTP',
                userName: '',
                password: '',
                version: ''
            },
            pageMenu: {
                totalCount: 0,
                currentPage: 1,
                pageNo: 1, // 初始页
                pageSize: 10, // 每页个数
                pageSizes: [10, 20, 30, 40]
            },
            pushNew: [],
            esClusterId: ''
        };
    },
    methods: {
        tenantCheck() {
            this.dialogUser = false;
            this.pushNew.length = 0;
        },
        // 租户绑定
        pushEs() {
            this.pushNew.length = 0;
            (this.bindTenant).forEach(element => {
                if (this.bindTenantCopy.indexOf(element) === -1) {
                    this.pushNew.push({ esClusterId: this.esClusterId, tenantCode: element, operateType: 'NEW' });
                }
            });
            if (this.pushNew.length > 0) {
                newQuota(this.pushNew).then(res => {
                    if (res.code === '0') {
                        this.$message.success(this.$translate('lang.E3202103100018', { defaultText: '绑定成功' }));
                        this.pushNew.push({ id: 1 });
                        this.dialogUser = false;
                        this.pushNew.length = 0;
                    }
                });
            } else {
                this.$message.warning(this.$translate('lang.E3202103100019', { defaultText: '请选择租户进行绑定' }));
            }
        },
        // 点击用户-集群绑定
        changUser(row) {
            this.esClusterId = row.id;
            clusterBinding(row.id).then(res => {
                this.bindTenantCopy = res.data.bindTenant;
                this.bindTenant = res.data.bindTenant;
                this.allTenant = res.data.allTenant;
                this.dialogUser = true;
            });
        },
        checkOldAdress(row) {
            Object.keys(this.oldAdress).forEach(key => {
                this.oldAdress[key] = row[key];
            });
        },
        // 修改地址
        pushAdressChange() {
            this.$refs.adressChange.$refs.oldAdresss.validate(valid => {
                if (valid) {
                    const changeData = this.$refs.adressChange.oldAdresss;
                    adressCut({
                        headerId: changeData.headerId,
                        address: changeData.address,
                        port: Number(changeData.port),
                        version: changeData.version,
                        id: changeData.id
                    }).then(res => {
                        this.newAdressOn = false;
                        this.$message.success(this.$translate('lang.EXC202103010014', { defaultText: '保存成功' }));
                        getAdress({
                            headerId: this.headerId,
                            pageNo: 1,
                            pageSize: 99
                        }).then(res => {
                            this.addressSet = res.data.list;
                            this.dialogVisibleAdress = true;
                        });
                    });
                }
            });
        },
        // 打开新增地址窗口
        openAdressNew() {
            this.copyOldAdress.headerId = this.headerId;
            Object.keys(this.oldAdress).forEach(key => {
                this.oldAdress[key] = this.copyOldAdress[key];
            });
            this.newAdressOn = true;
        },
        // 地址状态更改
        adressState(value) {
            if (value.state === 0) {
                changeAdressState({
                    id: value.id,
                    avail: true,
                    version: value.version
                }).then(res => {
                    this.getInf();
                    getAdress({
                        headerId: this.headerId,
                        pageNo: 1,
                        pageSize: 99
                    }).then(res => {
                        this.addressSet = res.data.list;
                        this.dialogVisibleAdress = true;
                    });
                });
            } else {
                changeAdressState({
                    id: value.id,
                    avail: false,
                    version: value.version
                }).then(res => {
                    this.getInf();
                    getAdress({
                        headerId: this.headerId,
                        pageNo: 1,
                        pageSize: 99
                    }).then(res => {
                        this.addressSet = res.data.list;
                        this.dialogVisibleAdress = true;
                    });
                });
            }
        },
        // 显示地址
        adressMenu(row) {
            this.headerId = row.id;
            getAdress({
                headerId: row.id,
                pageNo: 1,
                pageSize: 99
            }).then(res => {
                this.addressSet = res.data.list;
                this.dialogVisibleAdress = true;
            });
        },
        // 主页 狀態更改
        stateCode(value) {
            if (value.state === 0) {
                changeState({
                    id: value.id,
                    avail: true,
                    version: value.version
                }).then(res => {
                    this.$message.success(this.$translate('lang.E3202103100020', { defaultText: '启用成功' }));
                    this.getInf();
                });
            } else {
                changeState({
                    id: value.id,
                    avail: false,
                    version: value.version
                }).then(res => {
                    this.$message.success(this.$translate('lang.E3202103100021', { defaultText: '禁用成功' }));
                    this.getInf();
                });
            }
        },
        pushConfig(row) {
            Object.keys(this.changeData).forEach(key => {
                this.changeData[key] = row[key];
            });
            this.dialogVisible = true;
        },
        // 配置新增/修改
        changeConfig(row) {
            this.$refs.config.$refs.tableList.validate(valid => {
                if (valid) {
                    this.changeConfigBlock = true;
                    const pushData = this.$refs.config.tableList;
                    changeInfo({
                        id: pushData.id,
                        clusterName: pushData.clusterName,
                        protocal: pushData.protocal,
                        userName: pushData.userName,
                        password: pushData.password,
                        version: pushData.version
                    }).then(res => {
                        if (+res.code === 0) {
                            this.$message.success(this.$translate('lang.EXC202103010014', { defaultText: '保存成功' }));
                            this.getInf();
                        }
                        this.changeConfigBlock = false;
                    }).catch(() => {
                        this.changeConfigBlock = false;
                    });
                    this.dialogVisible = false;
                }
            });
        },
        searchCode(value) {
            this.pageState = false;
            this.pageMenu.pageNo = 1;
            this.searchBlock = true;
            this.getInf();
            this.$nextTick(() => {
                this.pageState = true;
            });
        },
        newCode() {
            Object.keys(this.changeData).forEach(key => {
                this.changeData[key] = this.copyChangeData[key];
            });
            this.dialogVisible = true;
        },
        // 分页1
        currentDom(val) {
            this.pageMenu.pageNo = val;
            this.getInf();
        },
        // 分页2
        sizeDom(val) {
            this.pageMenu.pageSize = val;
            this.getInf();
        },
        // 获取初始数据、数据查询
        getInf() {
            getESIndex({
                clusterName: this.$refs.search.queries.clusterName,
                protocal: this.$refs.search.queries.protocal,
                state: this.$refs.search.queries.state,
                pageNo: this.pageMenu.pageNo,
                pageSize: this.pageMenu.pageSize
            }).then(res => {
                this.tableData = res.data.list;
                this.pageMenu.totalCount = res.data.totalCount;
                this.searchBlock = false;
            }).catch(() => {
                this.searchBlock = false;
            });
        },
        //   取消集群配置修改对话框验证
        cancelCheck() {
            this.$refs.config.$refs.tableList.clearValidate();
            this.dialogVisible = false;
        },
        // 取消修改新增（地址、端口）对话框校验
        cancelTheCheck() {
            this.$refs.adressChange.$refs.oldAdresss.clearValidate();
            this.newAdressOn = false;
        }
    },
    components: {
        Paper,
        searchTenant,
        esTable,
        pageList,
        newDelate,
        modificationAddress,
        newAddress
    },
    created() {
        tenantList().then(res => {
            this.tenantList = res.data.list;
        });
    },
    mounted() {
        this.getInf();
    }
};
</script>
<style lang="less">
.es-config{
    .es-config-table{
        .el-table {
        height: calc(100vh - 180px) !important;
    }
    .row-bg {
        margin-top: 20px;
    }
    }
    .es-config-page{
        text-align: right;
        margin-top: 20px;
    }
    // 租户集群绑定对话框
    .cluster-binding-dialog{
        width: 600px;
    }
    // 集群配置-地址修改
    .cluster-address-modification-dialog{
        width: 500px;
    }
    .es-config-add{
        float: left;
        margin-top: 20px;
    }
    // 对话框取消按钮
    // .system-management-cancel-button{
    //     width: 88px;
    //     height: 32px;
    //     border: 1px solid #D9D9D9;
    // }
    // 对话框确定按钮
    // .system-management-confirm-button{
    //     width: 88px;
    //     height: 32px;
    //     background: #2BDBDC;
    //     border: 1px solid #2BDBDC;
    // }
    .el-form-item__label{
        padding: 0 10px 0 0;
    }

}
</style>